import { useState, useRef, useEffect } from "react";
import "./CustomDropdown.css";
import ValidIcon from "../../assets/icons/emergency_home.svg";
import SearchIcon from "../../assets/icons/search.svg"; // Assuming you have a search icon

const CustomDropdown = ({
  className = "",
  options = [],
  onSelectOption,
  placeholder = "Select an option",
  value = "",
  isError,
  isObjectDrop,
  keyName,
  previewKey = false,
  isRequired,
  label,
  showOptional,
  disabled = false,
  search = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  const dropdownPositionRef = useRef(null);
  const [openDropdownUpward, setOpenDropdownUpward] = useState(false);

  const displayValue = () => {
    if (!value) return placeholder;

    if (isObjectDrop) {
      const selectedOption = options.find(
        (option) => option[keyName] === value
      );
      return selectedOption
        ? selectedOption[previewKey ? "key" : keyName]
        : placeholder;
    }
    return value;
  };

  const handleSelect = (option) => {
    if (isObjectDrop) {
      onSelectOption(option);
    } else {
      onSelectOption(option);
    }
    setIsOpen(false);
    setSearchTerm("");
  };

  const filteredOptions =
    search && searchTerm
      ? options.filter((option) => {
          const optionValue = isObjectDrop
            ? option[previewKey ? "key" : keyName]?.toString()?.toLowerCase()
            : option?.toString()?.toLowerCase();
          return optionValue?.includes(searchTerm?.toLowerCase());
        })
      : options;

  // Close dropdown click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isOpen && search && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen, search]);

  const checkPositionAndSetDirection = () => {
    if (dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      setOpenDropdownUpward(rect.top > windowHeight / 2);
    }
  };

  return (
    (isRequired || (showOptional && !isRequired)) && (
      <div ref={dropdownPositionRef} className="flex flex-col form-detail">
        <div className="emp-form-label">
          {label}
          {isRequired && "*"}
        </div>

        <div
          className={`custom-dropdown-container ${
            isError && !value && isRequired ? "error-border" : ""
          }`}
          ref={dropdownRef}
        >
          {/* Custom select header */}
          <div
            className={`custom-dropdown-header ${className} ${
              value ? "select-value" : "select-placeholder"
            } ${disabled ? "disabled" : ""}`}
            onClick={() => {
              checkPositionAndSetDirection();
              !disabled && setIsOpen(!isOpen);
            }}
          >
            <div className="selected-value">{displayValue()}</div>
            <div className="dropdown-arrow"></div>
          </div>

          {/* Dropdown menu */}
          {isOpen && !disabled && (
            <div
              className={`custom-dropdown-menu ${
                openDropdownUpward ? "opens-up" : ""
              }`}
            >
              {/* Search input */}
              {search && (
                <div className="dropdown-search-container">
                  <img src={SearchIcon} alt="Search" className="search-icon" />
                  <input
                    ref={searchInputRef}
                    type="text"
                    className="dropdown-search-input"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    disabled={!options?.length}
                  />
                </div>
              )}

              {/* Options list */}
              <div className="dropdown-options-list">
                {filteredOptions.length > 0 ? (
                  filteredOptions.map((option, index) => (
                    <div
                      key={index}
                      className={`dropdown-option ${
                        (isObjectDrop && option[keyName] === value) ||
                        option === value
                          ? "selected"
                          : ""
                      }`}
                      onClick={() => handleSelect(option)}
                    >
                      {isObjectDrop
                        ? option[previewKey ? "key" : keyName]
                        : option}
                    </div>
                  ))
                ) : (
                  <div className="no-options">No matching options</div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Error message */}
        {isError && !value && isRequired && (
          <div className="valid-text flex items-center">
            <img src={ValidIcon} alt="" style={{ marginRight: "4px" }} />
            <div>Please select an option</div>
          </div>
        )}
      </div>
    )
  );
};

export default CustomDropdown;
